import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#031f30",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M12.164 1.52a1 1 0 0 0-.684-.27H4.125a1 1 0 0 0-1 1v15.5a1 1 0 0 0 1 1h11.75a1 1 0 0 0 1-1V6.37a1 1 0 0 0-.316-.729z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#031f30",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M11.875 1.25v5h5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#031f30",
      "fill-rule": "evenodd",
      d: "M9.637 15.412a3 3 0 0 0 3-3h-3v-3a3.001 3.001 0 0 0 0 6",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#031f30",
      "fill-rule": "evenodd",
      d: "M10 9v3h3a3 3 0 0 0-3-3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }